import { useMemo, useContext } from 'react';
import { AuthContext } from '../../HubLayout/models/AuthContext';

import { HubIdTokenClaims } from '../../HubLayout/util/authUtils';

/**
 * Returns the list of app roles from the current user's idTokenClaims.
 * Returns an empty array if no user is authenticated or no roles are present.
 */
export const useUserRoles = (): string[] => {
    const { authContext } = useContext(AuthContext);

    return useMemo(() => {
        try {
            const roles = (authContext.user?.idTokenClaims as HubIdTokenClaims)
                ?.roles;
            if (Array.isArray(roles)) return roles;
            if (typeof roles === 'string') return [roles];
            return [];
        } catch {
            return [];
        }
    }, [authContext.user]);
};
